import { Theme, THEME_STORAGE_KEY } from '../models/theme';

/**
 * Get the user's current preferred theme. We read local storage first for the preference. Otherwise,
 * it checks (prefers-color-scheme: dark).
 * @returns The user's current preferred theme
 */
export const getPreferredTheme = (): Theme => {
  if (localStorage.getItem(THEME_STORAGE_KEY) !== null) {
    return localStorage.getItem(THEME_STORAGE_KEY) === 'light'
      ? 'light'
      : 'dark';
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
};
